import FragmentSummary from "./fragment-summary";
import Pass from "./pass";

export default class FieldGoalFakePass extends Pass {
    summarize(summaryContext, stringifier) {
        const message = ` faked, ${stringifier.firstInitial(this.passedBy)}`;
        return new FragmentSummary(message);
    }

    getScoringPoints(gameConfig) {
        return gameConfig.scoring.runPAT;
    }
}
